import type { StaticImageData } from 'next/image'
import PixelBackground from './images/pixel/pixel_center.svg'
import PixelLeftDecorator from './images/pixel/pixel_left_decorator.svg'
import PixelRightDecorator from './images/pixel/pixel_right_decorator.svg'
import PrideBackground from './images/pride/pride_center.svg'
import PrideLeftDecorator from './images/pride/pride_left_decorator.svg'
import PrideRightDecorator from './images/pride/pride_right_decorator.svg'
import SakuraBackground from './images/sakura/sakura_center.svg'
import SakuraLeftDecorator from './images/sakura/sakura_left_decorator.svg'
import SakuraRightDecorator from './images/sakura/sakura_right_decorator.svg'
import StandardBackground from './images/standard/standard_center.svg'
import StandardLeftDecorator from './images/standard/standard_left_decorator.svg'
import StandardRightDecorator from './images/standard/standard_right_decorator.svg'

export const widgetStyleConfig = {
  standard: {
    fontFamily: 'Fira Sans',
    fontWeights: [700, 900],
    leftDecorator: StandardLeftDecorator as StaticImageData,
    rightDecorator: StandardRightDecorator as StaticImageData,
    background: StandardBackground as StaticImageData,
  },
  pixel: {
    fontFamily: 'Jersey 10',
    fontWeights: [400],
    leftDecorator: PixelLeftDecorator as StaticImageData,
    rightDecorator: PixelRightDecorator as StaticImageData,
    background: PixelBackground as StaticImageData,
  },
  sakura: {
    fontFamily: 'Merienda',
    fontWeights: [700],
    leftDecorator: SakuraLeftDecorator as StaticImageData,
    rightDecorator: SakuraRightDecorator as StaticImageData,
    background: SakuraBackground as StaticImageData,
    dataColor: '',
  },
  pride: {
    fontFamily: 'Fira Sans',
    fontWeights: [700, 900],
    leftDecorator: PrideLeftDecorator as StaticImageData,
    rightDecorator: PrideRightDecorator as StaticImageData,
    background: PrideBackground as StaticImageData,
  },
}
